import React from 'react';
import { Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';


const Header = () => {
  const navigate = useNavigate();

  return (
    <Box
        sx={{
          backgroundColor: '#c2c5c6',
          padding: { xs: '80px 10px', sm: '100px 20px 50px' }, // Espaciado dinámico
          textAlign: 'center',
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 'bold',
            color: '#2c3e50',
            marginBottom: { xs: '16px', sm: '20px' },
            fontSize: { xs: '1.2rem', sm: '2.5rem' }, // Tamaños dinámicos
          }}
        >
          MAESTRIA EN ULTRASONIDO DIAGNOSTICO
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            color: '#34495e',
            marginBottom: { xs: '10px', sm: '30px' },
            fontSize: { xs: '1rem', sm: '1.5rem' },
          }}
        >
          DURACION 2 AÑOS
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            color: '#34495e',
            marginBottom: { xs: '10px', sm: '30px' },
            fontSize: { xs: '1rem', sm: '1.5rem' },
          }}
        >
          PRACTICA TUTORIADA CADA 15 DIAS
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            color: '#34495e',
            marginBottom: { xs: '10px', sm: '30px' },
            fontSize: { xs: '1rem', sm: '1.5rem' },
          }}
        >
         RECONOCIMIENTO DE VALIDEZ OFICIAL DE ESTUDIOS (REVOE) PSU-42/2011
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            color: '#34495e',
            marginBottom: { xs: '10px', sm: '30px' },
            fontSize: { xs: '1rem', sm: '1.5rem' },
          }}
        >
         DICTAMEN FAVORABLE DE LA SECRETRIA DE SALUD NO. 5003/4407
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            color: '#34495e',
            marginBottom: { xs: '10px', sm: '30px' },
            fontSize: { xs: '1rem', sm: '1.5rem' },
          }}
        >
         CLAVE ANTE LA DIRECCION GENERAL DE PROFESIONES 413517
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '0.9rem', sm: '1.2rem' },
            color: '#7f8c8d',
            marginBottom: { xs: '20px', sm: '40px' },
            maxWidth: { xs: '100%', sm: '800px' },
            margin: '0 auto',
          }}
        >
          DURACION 4 SEMESTRES (SESIONES QUINCENALES)
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '0.9rem', sm: '1.2rem' },
            color: '#7f8c8d',
            marginBottom: { xs: '20px', sm: '40px' },
            maxWidth: { xs: '100%', sm: '800px' },
            margin: '0 auto',
          }}
        >
          VIERNES DE 17:00 A 22:00 HRS. (EN LINEA)
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '0.9rem', sm: '1.2rem' },
            color: '#7f8c8d',
            marginBottom: { xs: '20px', sm: '40px' },
            maxWidth: { xs: '100%', sm: '800px' },
            margin: '0 auto',
          }}
        >
          SABADOS DE 9:00 A 14:00 HRS. (PRESENCIAL)
        </Typography>
        <Button
        onClick={() => navigate('/Contact')}
        variant="contained"
        sx={{
          px: { xs: 3, md: 4 },
          py: { xs: 1, md: 1.5 },
          fontSize: { xs: '0.9rem', md: '1rem' },
          fontWeight: 600,
          color: '#fff',
          backgroundColor: 'rgb(51, 64, 64)',
          borderRadius: '10px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: 'rgb(41, 54, 54)',
            transform: 'scale(1.05)',
            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
          },
        }}
        endIcon={<ArrowForwardIosIcon />}
      >
        Inscríbete Ahora
      </Button>
      </Box>
  );
};

export default Header;
